import {BaseModel} from "../base";
import {resource} from "../../services/resource";

class ResourceModel extends BaseModel {

    /**
     * @description
     * Static function that loads an array of resources from a company object
     *
     * @returns {promise} A returned promise
     */
    static $query(company) {
        return resource.query(company);
    }
}

export {
    ResourceModel
}